import React, { memo } from 'react';
import type { Question, Locale } from '@types';
import styles from './QuestionItem.module.css';

interface QuestionItemProps {
    question: Question;
    value: string;
    onChange: (value: string) => void;
    locale: Locale;
}

/**
 * Individual question component with text input or textarea
 */
export const QuestionItem = memo(function QuestionItem({
    question,
    value,
    onChange,
    locale
}: QuestionItemProps) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onChange(e.target.value);
    };

    const questionText = question.question[locale];
    const placeholder = question.placeholder?.[locale] || '';

    return (
        <div className={styles.question_item}>
            <label className={styles.question_label} htmlFor={question.id}>
                {questionText}
                {question.required && <span className={styles.required}> *</span>}
            </label>

            {question.inputType === 'textarea' ? (
                <textarea
                    id={question.id}
                    className={styles.question_textarea}
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                    required={question.required}
                    rows={4}
                />
            ) : (
                <input
                    id={question.id}
                    type={question.inputType}
                    className={styles.question_input}
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                    required={question.required}
                />
            )}
        </div>
    );
});